import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import LoadPostChartAndTable from "../Dashboard/LoadPostChartAndTable";
import LoadPostByErpUser from "../Dashboard/LoadPostByErpUser";
import AppDownloads from "../Dashboard/AppDownloads";
import TruckPostByAccountManager from "../Dashboard/TruckPostByAccountManager";
import PageActivity from "../Dashboard/PageActivity";
import LoadPostByAccountmanager from "../Dashboard/LoadPostByAccountmanager";
import TrackShipmentByAccount from "../Dashboard/TrackShipmentByAccount";
import UserActivity from "../Dashboard/UserActivity";
import LiveData from "../Dashboard/LiveData";
import NotificationActivity from "../Dashboard/NotificationActivity";
import AccountActivityStatus from "../Dashboard/AccountActivityStatus";
import LaneAdded from "../Dashboard/LaneAdded";
import { KYCCompleted } from "../Dashboard/KYCCompleted";
import CallReport from "../CallReport/CallReport";
import "./EmtReports.scss";
import DailyPageActivity from "../DailyPageActivity/DailyPageActivity";

const EmtReports = () => {
  const title = "EmtReports";
  const statusTabs = [
    { name: "All" },
    { name: "Load_Post_Erp" },
    { name: "App_Details" },
    { name: "Account_Load_Post" },
    { name: "Truck_Post_details" },
    { name: "Page_Activity_Details" },
    { name: "Track_Details" },
    { name: "Load_Post_Details" },
    { name: "User_Activity" },
    { name: "Notification_Activity" },
    { name: "Account_Activity_Status" },
    { name: "Lane Not Added" },
    { name: "KYC Incompleted" },
    { name: "CallReport" },
    { name: "Daily_Page_Activity" },
  ];

  const dispatch = useDispatch();
  const reduxTab = useSelector((store) => store?.UniqueTabReducer?.[title]);
  const urlParams = new URLSearchParams(window.location.search);

  // Use "activeTab" for clarity
  const [activeTab, setActiveTab] = useState(() => {
    return urlParams.get("tab") || reduxTab || "Emt_Load_Details";
  });

  // Determine active index based on the URL parameter
  const activeIndex = statusTabs.findIndex((tab) => tab.name === urlParams.get("tab"));

  useEffect(() => {
    // Update Redux store with the active tab
    dispatch({
      type: "UNIQUE_TAB_SELECT",
      payload: { key: title, data: activeTab },
    });

    // Update the URL query parameter
    const params = new URLSearchParams(window.location.search);
    params.set("tab", activeTab);
    window.history.pushState({}, "", `${window.location.pathname}?${params.toString()}`);
  }, [activeTab, dispatch, title]);

  // Map each tab to its corresponding component.
  const tabComponentMap = {
    All: <LiveData />,
    Load_Post_Erp: <LoadPostByErpUser />,
    App_Details: <AppDownloads />,
    Track_Details: <TrackShipmentByAccount />,
    Truck_Post_details: <TruckPostByAccountManager />,
    Page_Activity_Details: <PageActivity />,
    Account_Load_Post: <LoadPostByAccountmanager />,
    Load_Post_Details: <LoadPostChartAndTable />,
    User_Activity: <UserActivity />,
    Notification_Activity: <NotificationActivity />,
    Account_Activity_Status: <AccountActivityStatus />,
    "Lane Not Added": <LaneAdded />,
    "KYC Incompleted": <KYCCompleted />,
    CallReport: <CallReport />,
    Daily_Page_Activity: <DailyPageActivity />,
  };

  // Fallback to LiveData if no matching component is found
  const ComponentToRender = tabComponentMap[activeTab] || <LiveData />;

  return (
    <div>
      <Tabs tabs={statusTabs} SetTabPage={setActiveTab} ActiveIndex={activeIndex} />
      <div className="EMTReportContainer">{ComponentToRender}</div>
    </div>
  );
};

export default EmtReports;
